<script setup lang="ts">
import { PartnerCard, type PartnerCardPartner } from '@/features/partners';
import { useContextToasts } from '@glow/shared/composables/useContextToasts';
import { type FragmentType, graphql } from '@/gql';
import { useRoutes } from '@glow/shared/lib/routes';

const companyFragment = graphql(/* GraphQL */ `
  fragment CompanyCard_CompanyFragment on Company {
    id
    name
    slug
    address
    location
    logoUrl
    yearsOnMarket
    reviewCount
  }
`);

const props = defineProps<{
  company: FragmentType<typeof companyFragment>;
}>();

const company = useFragmentData(companyFragment, () => props.company);
const { getUrl } = useRoutes();
const partner = computed<PartnerCardPartner>(() => ({
  link: getUrl('partnerDetails', {
    type: 'company',
    partner: company.value.slug,
    city: 'moscow', // FIXME
  }),
  ...company.value,
}));

const { executeMutation: updateLikedState } = useMutation(
  graphql(/** GraphQL */ `
    mutation CompanyCard_UpdateCompanyLikedState(
      $id: Int!
      $newIsLiked: Boolean!
    ) {
      updateCompanyLikedState(id: $id, newIsLiked: $newIsLiked) {
        isLiked
      }
    }
  `)
);
const { showLikedToast } = useContextToasts();

async function onLikedStateUpdate(newIsLiked: boolean) {
  await updateLikedState({ id: company.value.id, newIsLiked });
  showLikedToast(newIsLiked);
}
</script>

<template>
  <PartnerCard
    :partner="partner"
    :with-message-button="false"
    @update-liked-state="onLikedStateUpdate"
  />
</template>
